// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
}

button:focus {
  outline: none !important;
}

.btn.disabled, .btn:disabled {
  opacity: 0.38;
}`, "",{"version":3,"sources":["webpack://./src/app/dashboard/containers/manage-respondents-shell/manage-respondents-shell.component.scss","webpack://./../../01.%20UI/NgHsSurveyClient/src/app/dashboard/containers/manage-respondents-shell/manage-respondents-shell.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;ACCF;;ADEA;EACE,wBAAA;ACCF;;ADEA;EACE,aAAA;ACCF","sourcesContent":[":host {\r\n  display: block;\r\n  height: 100%;\r\n}\r\n\r\nbutton:focus {\r\n  outline: none !important;\r\n}\r\n\r\n.btn.disabled, .btn:disabled {\r\n  opacity: 0.38;\r\n}\r\n",":host {\n  display: block;\n  height: 100%;\n}\n\nbutton:focus {\n  outline: none !important;\n}\n\n.btn.disabled, .btn:disabled {\n  opacity: 0.38;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
